module.exports = __webpack_public_path__ + "img/36_20.8d661b8b.png";